/**
 * 充值弹窗全局状态管理
 * 用于在任意位置打开充值弹窗（如积分不足时）
 */

import { ref } from 'vue';

/** 充值弹窗显示状态 */
const showRechargeModal = ref(false);

/** 打开充值弹窗 */
export function openRechargeModal() {
  showRechargeModal.value = true;
}

/** 关闭充值弹窗 */
export function closeRechargeModal() {
  showRechargeModal.value = false;
}

/** 获取充值弹窗状态 */
export function useRechargeModal() {
  return {
    showRechargeModal,
    openRechargeModal,
    closeRechargeModal,
  };
}
